import { CalendarItem, CalendarItemType } from './shared';
import { useMemo } from 'react';
import { useSocialPosts } from './useSocialPosts';
import moment from 'moment';

export const useCalendarEvents = ({
  day,
  month,
  year,
}: {
  day?: number;
  month?: number;
  year?: number;
}): CalendarItem[] => {
  const { socialPosts } = useSocialPosts();

  const events = useMemo<CalendarItem[]>(() => {
    const socialPostSchedules = socialPosts
      .filter(socialPost => socialPost)
      .map<CalendarItem>(socialPost => {
        const publishAt = socialPost.publish_at as any;
        const publishedDate = moment.utc(publishAt);
        return {
          date: publishAt,
          date_day: publishedDate.date(),
          date_month: publishedDate.month(),
          date_year: publishedDate.year(),
          description: socialPost.content,
          name: `Upcoming social post ${socialPost.id}`,
          social_post_id: socialPost.id,
          type: CalendarItemType.OnceTimeOff,
        };
      });

    let _events: CalendarItem[] = [...socialPostSchedules];
    if (month) {
      _events = _events.filter(event => event.date_month === month);
    }
    if (day) {
      _events = _events.filter(event => event.date_day === day);
    }
    if (year) {
      _events = _events.filter(event => event.date_year === year);
    }
    return _events;
  }, [socialPosts, day, month, year]);
  return events;
};
